import { c as _c } from "react/compiler-runtime";
import React from "react";
import { WaveWinnersDrop } from "./WaveWinnersDrop";
import { ApiWave } from "@/generated/models/ApiWave";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { ApiWaveDecisionWinner } from "@/generated/models/ObjectSerializer";
interface WaveWinnersDropsProps {
  readonly wave: ApiWave;
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly winners: ApiWaveDecisionWinner[];
  readonly isLoading?: boolean;
}
export const WaveWinnersDrops: React.FC<WaveWinnersDropsProps> = t0 => {
  const $ = _c(11);
  const {
    wave,
    onDropClick,
    winners,
    isLoading: t1
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  if (isLoading) {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="tw-w-full tw-h-0.5 tw-bg-iron-800 tw-overflow-hidden"><div className="tw-w-full tw-h-full tw-bg-indigo-400 tw-animate-loading-bar" /></div>;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    return t2;
  }
  if (!winners.length) {
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <></>;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  let t2;
  if ($[2] !== onDropClick || $[3] !== wave || $[4] !== winners) {
    let t3;
    if ($[6] !== onDropClick || $[7] !== wave) {
      t3 = winner => <WaveWinnersDrop key={winner.drop.id} winner={winner} wave={wave} onDropClick={onDropClick} />;
      $[6] = onDropClick;
      $[7] = wave;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = winners.map(t3);
    $[2] = onDropClick;
    $[3] = wave;
    $[4] = winners;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[9] !== t2) {
    t3 = <div className="tw-space-y-3">{t2}</div>;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};